export default {"src":"/_next/static/media/icon_clock_circle.dbd5fd17.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};